module.exports = __webpack_public_path__ + "static/media/billon-empty-document-list.7abf264b.png";